import * as React from "react";
export class Events extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-racing-current-races__events-wrapper" },
            React.createElement("div", { className: "rj-racing-current-races__events" }, this.props.children)));
    }
}
//# sourceMappingURL=Events.js.map